import { styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

import { headerLabelStyles } from '../../ui'
import {
  CONTROL_HEIGHT,
  DIVIDER_SPACING,
  DIVIDER_WIDTH,
} from '../getActionPanelWidth'

/**
 * The header's two halves, over the panel's two halves.
 *
 * Publishes the form's width like the panel does, to align the divider.
 */
export const Header = styled.div<{ $formWidth: number }>`
  --action-form-width: ${(o) => o.$formWidth}px;

  align-items: center;
  display: flex;
  gap: ${DIVIDER_SPACING}px;
  width: 100%;
`

/**
 * Sits above `ActionForm` and matches its width.
 */
export const FormHalf = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 var(--action-form-width);
  gap: 0.5rem;
  min-width: 0;
  overflow: hidden;
`

/**
 * Sits above `ActionMenu`, and has the same divider on its left border.
 */
export const MenuHalf = styled.div`
  align-items: center;
  border-left: ${DIVIDER_WIDTH}px solid ${Colors.Semantic.Neutral.medium_grey};
  display: flex;
  flex: 1;
  height: ${CONTROL_HEIGHT}px;
  justify-content: flex-end;
  padding-left: ${DIVIDER_SPACING}px;
`

/**
 * Replacing the default header gives up `.ag-header-cell-label` -- which is
 * where every other column's title gets its styling -- so we share them.
 */
export const HeaderLabel = styled.span`
  ${headerLabelStyles}
`
